module.exports = {"id":"185239","name":"Ömer Toprak","rating":"82","photo":"./data/images/photos/4/185239.png","club":{"name":"Bor. Dortmund","logo":"./data/images/clubs/Bor.Dortmund.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OmerToprak0.json
// module id = 3288
// module chunks = 0